import { List, OrderedMap, Set } from 'immutable';
import React, { PureComponent, ReactNode } from 'react';
import Button from '~/UI/Button/Button';
import Icon from '~/UI/Icon/Icon';

import styles from './styles.less';

interface Props {
	path: List<string>;
	collapseKeys: Set<string> | Set<unknown>;
	values: OrderedMap<string, any>;
	renderSubTree(tree: { [key in string]: any }, a: List<string>): ReactNode;
	root?: boolean;
	emptyValue: string | null;
	onToggleItem(key: string, path: List<string>): any;
}

export default class Tree extends PureComponent<Props> {
	static defaultProps = {
		root: false,
		emptyValue: null,
	};

	render() {
		const { values, root } = this.props;

		return <ul className={root ? styles.rootList : styles.list}>{values.map(this.renderItem).toList().toArray()}</ul>;
	}

	renderItem = (value: any, key: string) => {
		const { path, renderSubTree, emptyValue, collapseKeys } = this.props;
		const isTree = value !== null && typeof value === 'object' && !React.isValidElement(value);

		return (
			<li className={value === null ? '' : styles.item} key={key}>
				{isTree ? (
					this.renderButton(key, Object.keys(value).length)
				) : (
					<strong className={styles.itemLabel}>{key}:</strong>
				)}
				{isTree ? (
					collapseKeys.has(key) ? (
						value.size
					) : (
						renderSubTree(value, path.push(key))
					)
				) : value === null ? (
					<span className={styles.emptyValue}>{emptyValue}</span>
				) : (
					this.renderValue(value)
				)}
			</li>
		);
	};

	renderButton(key: string, valuesCount: number) {
		const { collapseKeys } = this.props;

		return (
			<Button disabled={valuesCount === 0} styles={{ button: styles.itemLabel }} onClick={() => this.toggleItem(key)}>
				<strong>{key}</strong> <span className={styles.count}>({valuesCount} values)</span>{' '}
				{valuesCount > 0 ? <Icon name={collapseKeys.has(key) ? 'triangle-right' : 'triangle-down'} /> : null}
			</Button>
		);
	}

	renderValue(value: any) {
		if (value === true) {
			return 'yes';
		}
		if (value === false) {
			return 'no';
		}
		return value;
	}

	toggleItem(key: string) {
		const { path, onToggleItem } = this.props;
		onToggleItem(key, path);
	}
}
